export const MODULE_TYPE = {
  ENQUIRY: 'enquiry',
  VIEWINGS: 'viewings',
}
